
import {
    I24Support,
    I3DCubeScan,
    I3Dcube,
    I3DRotate,
    I3DSquare,
    I3Square,
    Activity,
    AddCircle,
    Add,
    AddSquare,
    Airdrop,
    Airplane,
    AirplaneSquare,
    Airpod,
    Airpods,
    Alarm,
    AlignBottom,
    AlignHorizontally,
    AlignLeft,
    AlignRight,
    AlignTop,
    AlignVertically,
    Aquarius,
    Archive,
    ArchiveAdd,
    ArchiveBook,
    ArchiveBox,
    ArchiveMinus,
    ArchiveSlash,
    ArchiveTick,
    ArrangeHorizontal,
    ArrangeHorizontalCircle,
    ArrangeHorizontalSquare,
    ArrangeVertical,
    ArrangeVerticalCircle,
    ArrangeVerticalSquare,
    Arrow,
    ArrowCircleDown,
    ArrowCircleDown2,
    ArrowCircleLeft,
    ArrowCircleLeft2,
    ArrowCircleRight,
    ArrowCircleRight2,
    ArrowCircleUp,
    ArrowCircleUp2,
    ArrowDown,
    ArrowDown2,
    ArrowDown3,
    ArrowForward,
    ArrowForwardSquare,
    ArrowLeft,
    ArrowLeft2,
    ArrowLeft3,
    ArrowRight,
    ArrowRight2,
    ArrowRight3,
    ArrowRotateLeft,
    ArrowRotateRight,
    ArrowSquare,
    ArrowSquareDown,
    ArrowSquareLeft,
    ArrowSquareRight,
    ArrowSquareUp,
    ArrowSwapHorizontal,
    ArrowSwapVertical,
    ArrowUp,
    ArrowUp2,
    ArrowUp3,
    AttachCircle,
    AttachSquare,
    AudioSquare,
    Award,
    Back,
    BackSquare,
    Backward,
    Backward5Seconds,
    Backward10Seconds,
    Backward15Seconds,
    Bag,
    Bag2,
    BagCross,
    BagCross1,
    BagHappy,
    BagTick,
    BagTick2,
    BagTimer,
    Bank,
    Barcode,
    BatteryCharging,
    BatteryDisable,
    BatteryEmpty,
    BatteryEmpty1,
    BatteryFull,
    Be,
    Bezier,
    Bill,
    Bitcoin,
    BitcoinCard,
    BitcoinConvert,
    BitcoinRefresh,
    Blend,
    Blend2,
    Bluetooth,
    Bluetooth2,
    BluetoothCircle,
    BluetoothRectangle,
    Blur,
    Book,
    Book1,
    BookSaved,
    BookSquare,
    Bookmark,
    Bookmark2,
    Box,
    Box1,
    Box2,
    BoxAdd,
    BoxRemove,
    BoxSearch,
    BoxTick,
    BoxTime,
    Briefcase,
    BrifecaseCross,
    BrifecaseTick,
    BrifecaseTimer,
    Broom,
    Brush,
    Brush2,
    Brush3,
    BrushBig,
    BrushSquare,
    Bubble,
    Bucket,
    BucketCircle,
    BucketSquare,
    Building,
    Building3,
    Building4,
    Buildings,
    Buildings2,
    Bus,
    BuyCrypto,
    Cake,
    Calculator,
    Calendar,
    Calendar1,
    Calendar2,
    CalendarAdd,
    CalendarCircle,
    CalendarEdit,
    CalendarRemove,
    CalendarSearch,
    CalendarTick,
    Camera,
    CameraSlash,
    Candle,
    Candle2,
    Car,
    Card,
    CardAdd,
    CardCoin,
    CardEdit,
    CardPos,
    CardReceive,
    CardRemove,
    CardRemove1,
    CardSend,
    CardSlash,
    CardTick,
    CardTick1,
    Cards,
    Category,
    Category2,
    Cd,
    Chart,
    Chart1,
    Chart2,
    Chart21,
    ChartCircle,
    ChartFail,
    ChartSquare,
    ChartSuccess,
    Check,
    Chrome,
    Clipboard,
    ClipboardClose,
    ClipboardExport,
    ClipboardImport,
    ClipboardText,
    ClipboardTick,
    Clock,
    CloseCircle,
    CloseSquare,
    Cloud,
    CloudAdd,
    CloudChange,
    CloudConnection,
    CloudCross,
    CloudDrizzle,
    CloudFog,
    CloudLightning,
    CloudMinus,
    CloudNotif,
    CloudPlus,
    CloudRemove,
    CloudSnow,
    CloudSunny,
    Code,
    Code1,
    CodeCircle,
    Coffee,
    Coin,
    Coin1,
    ColorSwatch,
    Colorfilter,
    ColorsSquare,
    Command,
    CommandSquare,
    Component,
    Computing,
    Convert,
    Convert3DCube,
    ConvertCard,
    Convertshape,
    Convertshape2,
    Copy,
    CopySuccess,
    Copyright,
    Courthouse,
    CreativeCommons,
    Crop,
    Crown,
    Crown1,
    Cup,
    Danger,
    Data,
    Data2,
    Designtools,
    Devices,
    Diamonds,
    Direct,
    DirectDown,
    DirectInbox,
    DirectLeft,
    DirectNormal,
    DirectNotification,
    DirectRight,
    DirectSend,
    DirectUp,
    DirectboxDefault,
    DirectboxNotif,
    DirectboxReceive,
    DirectboxSend,
    Discover,
    Dislike,
    Document,
    DocumentCloud,
    DocumentCode,
    DocumentCode2,
    DocumentCopy,
    DocumentDownload,
    DocumentFavorite,
    DocumentFilter,
    DocumentForward,
    DocumentLike,
    DocumentPrevious,
    DocumentSketch,
    DocumentText,
    DocumentText1,
    DocumentUpload,
    Drop,
    Edit,
    Edit2,
    Electricity,
    Element,
    Element2,
    Element3,
    Element4,
    ElementEqual,
    ElementPlus,
    EmojiHappy,
    EmojiNormal,
    EmojiSad,
    EmptyWallet,
    EmptyWalletAdd,
    EmptyWalletChange,
    EmptyWalletRemove,
    EmptyWalletTick,
    EmptyWalletTime,
    Eraser,
    EraserSquare,
    Export,
    ExportCircle,
    ExportCurve,
    ExportSquare,
    ExternalDrive,
    Eye,
    EyeSlash,
    Fatrows,
    FavoriteChart,
    Filter,
    FilterAdd,
    FilterEdit,
    FilterRemove,
    FilterSearch,
    FilterSquare,
    FilterTick,
    FingerCricle,
    FingerScan,
    Firstline,
    Flag,
    Flag2,
    Flash,
    FlashCircle,
    FlashSlash,
    Flashy,
    Folder,
    Folder2,
    FolderAdd,
    FolderCloud,
    FolderConnection,
    FolderCross,
    FolderFavorite,
    FolderMinus,
    FolderOpen,
    Forbidden,
    Forbidden2,
    FormatCircle,
    FormatSquare,
    Forward,
    Forward5Seconds,
    Forward10Seconds,
    Forward15Seconds,
    ForwardItem,
    Gallery,
    GalleryAdd,
    GalleryEdit,
    GalleryExport,
    GalleryFavorite,
    GalleryImport,
    GalleryRemove,
    GallerySlash,
    GalleryTick,
    Game,
    Gameboy,
    GasStation,
    Gemini,
    Gemini2,
    Ghost,
    Gift,
    Glass,
    Global,
    GlobalEdit,
    GlobalRefresh,
    GlobalSearch,
    Google,
    Gps,
    GpsSlash,
    Grammerly,
    Graph,
    Grid1,
    Grid2,
    Grid3,
    Grid4,
    Grid5,
    Grid6,
    Grid7,
    Grid8,
    Grid9,
    GridEdit,
    GridEraser,
    GridLock,
    HambergerMenu,
    Happyemoji,
    Hashtag,
    HashtagDown,
    HashtagUp,
    Headphone,
    Headphones,
    Health,
    Heart,
    HeartAdd,
    HeartCircle,
    HeartEdit,
    HeartRemove,
    HeartSearch,
    HeartSlash,
    HeartTick,
    Hierarchy,
    Hierarchy2,
    Hierarchy3,
    HierarchySquare,
    HierarchySquare2,
    HierarchySquare3,
    Home,
    Home2,
    Home3,
    HomeHashtag,
    HomeTrendDown,
    HomeTrendUp,
    HomeWifi,
    Hospital,
    House,
    House2,
    Image,
    Import,
    ImportCircle,
    ImportCurve,
    ImportSquare,
    InfoCircle,
    Information,
    Instagram,
    Judge,
    Kanban,
    Key,
    Keyboard,
    KeyboardOpen,
    KeySquare,
    Lamp,
    LampCharge,
    LampOn,
    LampSlash,
    LanguageCircle,
    LanguageSquare,
    Layer,
    Level,
    Lifebuoy,
    Like,
    Like1,
    LikeDislike,
    LikeShapes,
    LikeTag,
    Link,
    Link1,
    Link2,
    Link21,
    LinkCircle,
    LinkSquare,
    Location,
    LocationAdd,
    LocationCross,
    LocationDiscover,
    LocationMinus,
    LocationSlash,
    LocationTick,
    Lock,
    Lock1,
    LockCircle,
    LockSlash,
    Login,
    LoginCurve,
    Logout,
    LogoutCurve,
    Lovely,
    MagicStar,
    Magicpen,
    MainComponent,
    Man,
    Map as MapIcon,
    Map1,
    Mask,
    MaskLeft,
    MaskRight,
    Math as MathIcon,
    Maximize,
    Maximize1,
    Maximize2,
    Maximize3,
    Maximize4,
    MaximizeCircle,
    Medal,
    MedalStar,
    Menu,
    MenuBoard,
    Message,
    Message2,
    MessageAdd,
    MessageAdd1,
    MessageCircle,
    MessageEdit,
    MessageFavorite,
    MessageMinus,
    MessageNotif,
    MessageProgramming,
    MessageQuestion,
    MessageRemove,
    MessageSearch,
    MessageSquare,
    MessageText,
    MessageText1,
    MessageTick,
    MessageTime,
    Messages,
    Messages1,
    Messages2,
    Messages3,
    Microphone,
    Microphone2,
    MicrophoneSlash,
    MicrophoneSlash1,
    Microscope,
    Milk,
    MiniMusicSqaure,
    Minus,
    MinusCirlce,
    MinusSquare,
    Mirror,
    MirroringScreen,
    Mobile,
    MobileProgramming,
    Monitor,
    MonitorMobbile,
    MonitorRecorder,
    Moon,
    More,
    More2,
    MoreCircle,
    MoreSquare,
    Mouse,
    MouseCircle,
    MouseSquare,
    Music,
    MusicCircle,
    MusicDashboard,
    MusicFilter,
    MusicLibrary2,
    MusicPlay,
    MusicPlaylist,
    MusicSquare,
    MusicSquareAdd,
    MusicSquareRemove,
    MusicSquareSearch,
    Musicnote,
    Next,
    Note,
    Note1,
    NoteAdd,
    NoteFavorite,
    NoteRemove,
    NoteSquare,
    NoteText,
    Notepad,
    Notepad2,
    Notification,
    Notification1,
    NotificationBing,
    NotificationCircle,
    NotificationFavorite,
    NotificationStatus,
    OmegaCircle,
    OmegaSquare,
    Paintbucket,
    Paperclip,
    Paperclip2,
    PasswordCheck,
    PathTool,
    PathTool2,
    PathToolSquare,
    Pause,
    PauseCircle,
    PenAdd,
    PenClose,
    PenRemove,
    PenTool,
    PenTool2,
    People,
    PercentageCircle,
    PercentageSquare,
    Personalcard,
    Pet,
    Pharagraphspacing,
    PictureFrame,
    Play,
    PlayAdd,
    PlayCircle,
    PlayCricle,
    PlayRemove,
    Pointer,
    PresentionChart,
    Previous,
    Printer,
    PrinterSlash,
    Profile,
    Profile2User,
    ProfileAdd,
    ProfileCircle,
    ProfileDelete,
    ProfileRemove,
    ProfileTick,
    ProgrammingArrow,
    ProgrammingArrows,
    QuoteDown,
    QuoteDownCircle,
    QuoteDownSquare,
    QuoteUp,
    QuoteUpCircle,
    QuoteUpSquare,
    Radar,
    Radar2,
    Radio,
    Ram,
    Ram2,
    Rank,
    Receive,
    ReceiveSquare,
    ReceiveSquare2,
    Record,
    RecordCircle,
    RecoveryConvert,
    Refresh,
    Refresh2,
    RefreshCircle,
    RefreshLeftSquare,
    RefreshRightSquare,
    RefreshSquare,
    Repeat,
    RepeatCircle,
    RepeateMusic,
    RepeateOne,
    Reserve,
    RotateLeft,
    RotateRight,
    RouteSquare,
    Routing,
    Routing2,
    RowHorizontal,
    RowVertical,
    Ruler,
    RulerPen,
    SafeHome,
    Sagittarius,
    Save2,
    SaveAdd,
    SaveMinus,
    SaveRemove,
    Scan,
    ScanBarcode,
    Scanner,
    Scanning,
    Scissor,
    Screenmirroring,
    Scroll,
    SearchFavorite,
    SearchFavorite1,
    SearchNormal,
    SearchNormal1,
    SearchStatus,
    SearchStatus1,
    SearchZoomIn,
    SearchZoomIn1,
    SearchZoomOut,
    SearchZoomOut1,
    Security,
    SecurityCard,
    SecuritySafe,
    SecurityTime,
    SecurityUser,
    Send,
    Send2,
    Setting,
    Setting2,
    Setting3,
    Setting4,
    Setting5,
    Settings,
    Shapes,
    Shapes1,
    Share,
    Shield,
    ShieldCross,
    ShieldSearch,
    ShieldSecurity,
    ShieldSlash,
    ShieldTick,
    Ship,
    Shop,
    ShopAdd,
    ShopRemove,
    ShoppingBag,
    ShoppingCart,
    Shuffle,
    SidebarBottom,
    SidebarLeft,
    SidebarRight,
    SidebarTop,
    Signpost,
    Simcard,
    Simcard1,
    Simcard2,
    Size,
    Slash,
    Slider,
    SliderHorizontal,
    SliderHorizontal1,
    SliderVertical,
    SliderVertical1,
    Smallcaps,
    SmartCar,
    SmartHome,
    Smileys,
    Sms,
    SmsEdit,
    SmsNotification,
    SmsSearch,
    SmsStar,
    SmsTracking,
    Sort,
    Sound,
    Speaker,
    Speedometer,
    Star,
    Star1,
    StarSlash,
    Status,
    StatusUp,
    Sticker,
    Stickynote,
    Stop,
    StopCircle,
    Story,
    Strongbox,
    Strongbox2,
    Subtitle,
    Sun,
    Sun1,
    SunFog,
    TableDocument,
    TableLamp,
    Tag,
    Tag2,
    TagCross,
    TagRight,
    TagUser,
    Task,
    TaskSquare,
    Teacher,
    Text,
    TextBlock,
    TextBold,
    TextItalic,
    TextUnderline,
    TextalignCenter,
    TextalignJustifycenter,
    TextalignJustifyleft,
    TextalignJustifyright,
    TextalignLeft,
    TextalignRight,
    Ticket,
    Ticket2,
    TicketDiscount,
    TicketExpired,
    TicketStar,
    Timer,
    Timer1,
    TimerPause,
    TimerStart,
    ToggleOff,
    ToggleOffCircle,
    ToggleOn,
    ToggleOnCircle,
    Trade,
    Translate,
    Trash,
    Tree,
    TrendDown,
    TrendUp,
    Triangle,
    TrushSquare,
    Truck,
    TruckFast,
    TruckRemove,
    TruckTick,
    TruckTime,
    Unlock,
    Unlimited,
    User,
    UserAdd,
    UserCirlceAdd,
    UserEdit,
    UserMinus,
    UserOctagon,
    UserRemove,
    UserSearch,
    UserSquare,
    UserTag,
    UserTick,
    Verify,
    Video,
    VideoAdd,
    VideoCircle,
    VideoHorizontal,
    VideoOctagon,
    VideoPlay,
    VideoRemove,
    VideoSlash,
    VideoSquare,
    VideoTick,
    VideoTime,
    VideoVertical,
    VoiceCricle,
    VoiceSquare,
    Volume,
    VolumeCross,
    VolumeHigh,
    VolumeLow,
    VolumeLow1,
    VolumeMute,
    VolumeSlash,
    VolumeUp,
    Wallet,
    Wallet1,
    Wallet2,
    Wallet3,
    WalletAdd,
    WalletAdd1,
    WalletCheck,
    WalletMinus,
    WalletMoney,
    WalletRemove,
    WalletSearch,
    Warning2,
    Watch,
    WatchStatus,
    Weight,
    WeightMeter,
    Wifi,
    WifiSquare,
    Wind,
    Wind2,
    Woman,
    WristClock,
    Icon,
    MoneyRecive,
} from "iconsax-react";


export interface IconSaxProps {
    className: string;
    iconName: string;
    color?: string;
}

export function IconSax({ className, iconName, color }: IconSaxProps) {
    if (!iconName || !saxIcons.get(iconName)) return null;
    const SaxIcon: Icon = saxIcons.get(iconName)!;
    return (
        <SaxIcon className={className} color={color} variant="Linear" size="1px" />
    )
}

const saxIcons: Map<string, Icon> = new Map([
    ["24-support", I24Support],
    ["3d-cube-scan", I3DCubeScan],
    ["3dcube", I3Dcube],
    ["3d-rotate", I3DRotate],
    ["3d-square", I3DSquare],
    ["3square", I3Square],
    ["activity", Activity],
    ["add", Add],
    ["add-circle", AddCircle],
    ["add-square", AddSquare],
    ["airdrop", Airdrop],
    ["airplane", Airplane],
    ["airplane-square", AirplaneSquare],
    ["airpod", Airpod],
    ["airpods", Airpods],
    ["alarm", Alarm],
    ["align-bottom", AlignBottom],
    ["align-horizontally", AlignHorizontally],
    ["align-left", AlignLeft],
    ["align-right", AlignRight],
    ["align-top", AlignTop],
    ["align-vertically", AlignVertically],
    ["aquarius", Aquarius],
    ["archive", Archive],
    ["archive-add", ArchiveAdd],
    ["archive-book", ArchiveBook],
    ["archive-box", ArchiveBox],
    ["archive-minus", ArchiveMinus],
    ["archive-slash", ArchiveSlash],
    ["archive-tick", ArchiveTick],
    ["arrange-horizontal", ArrangeHorizontal],
    ["arrange-horizontal-circle", ArrangeHorizontalCircle],
    ["arrange-horizontal-square", ArrangeHorizontalSquare],
    ["arrange-vertical", ArrangeVertical],
    ["arrange-vertical-circle", ArrangeVerticalCircle],
    ["arrange-vertical-square", ArrangeVerticalSquare],
    ["arrow", Arrow],
    ["arrow-circle-down", ArrowCircleDown],
    ["arrow-circle-down2", ArrowCircleDown2],
    ["arrow-circle-left", ArrowCircleLeft],
    ["arrow-circle-left2", ArrowCircleLeft2],
    ["arrow-circle-right", ArrowCircleRight],
    ["arrow-circle-right2", ArrowCircleRight2],
    ["arrow-circle-up", ArrowCircleUp],
    ["arrow-circle-up2", ArrowCircleUp2],
    ["arrow-down", ArrowDown],
    ["arrow-down2", ArrowDown2],
    ["arrow-down3", ArrowDown3],
    ["arrow-forward", ArrowForward],
    ["arrow-forward-square", ArrowForwardSquare],
    ["arrow-left", ArrowLeft],
    ["arrow-left2", ArrowLeft2],
    ["arrow-left3", ArrowLeft3],
    ["arrow-right", ArrowRight],
    ["arrow-right2", ArrowRight2],
    ["arrow-right3", ArrowRight3],
    ["arrow-rotate-left", ArrowRotateLeft],
    ["arrow-rotate-right", ArrowRotateRight],
    ["arrow-square", ArrowSquare],
    ["arrow-square-down", ArrowSquareDown],
    ["arrow-square-left", ArrowSquareLeft],
    ["arrow-square-right", ArrowSquareRight],
    ["arrow-square-up", ArrowSquareUp],
    ["arrow-swap-horizontal", ArrowSwapHorizontal],
    ["arrow-swap-vertical", ArrowSwapVertical],
    ["arrow-up", ArrowUp],
    ["arrow-up2", ArrowUp2],
    ["arrow-up3", ArrowUp3],
    ["attach-circle", AttachCircle],
    ["attach-square", AttachSquare],
    ["audio-square", AudioSquare],
    ["award", Award],
    ["back", Back],
    ["back-square", BackSquare],
    ["backward", Backward],
    ["backward-5-seconds", Backward5Seconds],
    ["backward-10-seconds", Backward10Seconds],
    ["backward-15-seconds", Backward15Seconds],
    ["bag", Bag],
    ["bag2", Bag2],
    ["bag-cross", BagCross],
    ["bag-cross-1", BagCross1],
    ["bag-happy", BagHappy],
    ["bag-tick", BagTick],
    ["bag-tick-2", BagTick2],
    ["bag-timer", BagTimer],
    ["bank", Bank],
    ["barcode", Barcode],
    ["battery-charging", BatteryCharging],
    ["battery-disable", BatteryDisable],
    ["battery-empty", BatteryEmpty],
    ["battery-empty-1", BatteryEmpty1],
    ["battery-full", BatteryFull],
    ["be", Be],
    ["bezier", Bezier],
    ["bill", Bill],
    ["bitcoin", Bitcoin],
    ["bitcoin-card", BitcoinCard],
    ["bitcoin-convert", BitcoinConvert],
    ["bitcoin-refresh", BitcoinRefresh],
    ["blend", Blend],
    ["blend-2", Blend2],
    ["bluetooth", Bluetooth],
    ["bluetooth-2", Bluetooth2],
    ["bluetooth-circle", BluetoothCircle],
    ["bluetooth-rectangle", BluetoothRectangle],
    ["blur", Blur],
    ["book", Book],
    ["book-1", Book1],
    ["book-saved", BookSaved],
    ["book-square", BookSquare],
    ["bookmark", Bookmark],
    ["bookmark-2", Bookmark2],
    ["box", Box],
    ["box-1", Box1],
    ["box-2", Box2],
    ["box-add", BoxAdd],
    ["box-remove", BoxRemove],
    ["box-search", BoxSearch],
    ["box-tick", BoxTick],
    ["box-time", BoxTime],
    ["briefcase", Briefcase],
    ["brifecase-cross", BrifecaseCross],
    ["brifecase-tick", BrifecaseTick],
    ["brifecase-timer", BrifecaseTimer],
    ["broom", Broom],
    ["brush", Brush],
    ["brush-2", Brush2],
    ["brush-3", Brush3],
    ["brush-big", BrushBig],
    ["brush-square", BrushSquare],
    ["bubble", Bubble],
    ["bucket", Bucket],
    ["bucket-circle", BucketCircle],
    ["bucket-square", BucketSquare],
    ["building", Building],
    ["building-3", Building3],
    ["building-4", Building4],
    ["buildings", Buildings],
    ["buildings-2", Buildings2],
    ["bus", Bus],
    ["buy-crypto", BuyCrypto],
    ["cake", Cake],
    ["calculator", Calculator],
    ["calendar", Calendar],
    ["calendar-1", Calendar1],
    ["calendar-2", Calendar2],
    ["calendar-add", CalendarAdd],
    ["calendar-circle", CalendarCircle],
    ["calendar-edit", CalendarEdit],
    ["calendar-remove", CalendarRemove],
    ["calendar-search", CalendarSearch],
    ["calendar-tick", CalendarTick],
    ["camera", Camera],
    ["camera-slash", CameraSlash],
    ["candle", Candle],
    ["candle-2", Candle2],
    ["car", Car],
    ["card", Card],
    ["card-add", CardAdd],
    ["card-coin", CardCoin],
    ["card-edit", CardEdit],
    ["card-pos", CardPos],
    ["card-receive", CardReceive],
    ["card-remove", CardRemove],
    ["card-remove-1", CardRemove1],
    ["card-send", CardSend],
    ["card-slash", CardSlash],
    ["card-tick", CardTick],
    ["card-tick-1", CardTick1],
    ["cards", Cards],
    ["category", Category],
    ["category-2", Category2],
    ["cd", Cd],
    ["chart", Chart],
    ["chart-1", Chart1],
    ["chart-2", Chart2],
    ["chart-21", Chart21],
    ["chart-circle", ChartCircle],
    ["chart-fail", ChartFail],
    ["chart-square", ChartSquare],
    ["chart-success", ChartSuccess],
    ["check", Check],
    ["chrome", Chrome],
    ["clipboard", Clipboard],
    ["clipboard-close", ClipboardClose],
    ["clipboard-export", ClipboardExport],
    ["clipboard-import", ClipboardImport],
    ["clipboard-text", ClipboardText],
    ["clipboard-tick", ClipboardTick],
    ["clock", Clock],
    ["close-circle", CloseCircle],
    ["close-square", CloseSquare],
    ["cloud", Cloud],
    ["cloud-add", CloudAdd],
    ["cloud-change", CloudChange],
    ["cloud-connection", CloudConnection],
    ["cloud-cross", CloudCross],
    ["cloud-drizzle", CloudDrizzle],
    ["cloud-fog", CloudFog],
    ["cloud-lightning", CloudLightning],
    ["cloud-minus", CloudMinus],
    ["cloud-notif", CloudNotif],
    ["cloud-plus", CloudPlus],
    ["cloud-remove", CloudRemove],
    ["cloud-snow", CloudSnow],
    ["cloud-sunny", CloudSunny],
    ["code", Code],
    ["code-1", Code1],
    ["code-circle", CodeCircle],
    ["coffee", Coffee],
    ["coin", Coin],
    ["coin-1", Coin1],
    ["color-swatch", ColorSwatch],
    ["colorfilter", Colorfilter],
    ["colors-square", ColorsSquare],
    ["command", Command],
    ["command-square", CommandSquare],
    ["component", Component],
    ["computing", Computing],
    ["convert", Convert],
    ["convert-3d-cube", Convert3DCube],
    ["convert-card", ConvertCard],
    ["convertshape", Convertshape],
    ["convertshape-2", Convertshape2],
    ["copy", Copy],
    ["copy-success", CopySuccess],
    ["copyright", Copyright],
    ["courthouse", Courthouse],
    ["creative-commons", CreativeCommons],
    ["crop", Crop],
    ["crown", Crown],
    ["crown-1", Crown1],
    ["cup", Cup],
    ["danger", Danger],
    ["data", Data],
    ["data-2", Data2],
    ["designtools", Designtools],
    ["devices", Devices],
    ["diamonds", Diamonds],
    ["direct", Direct],
    ["direct-down", DirectDown],
    ["direct-inbox", DirectInbox],
    ["direct-left", DirectLeft],
    ["direct-normal", DirectNormal],
    ["direct-notification", DirectNotification],
    ["direct-right", DirectRight],
    ["direct-send", DirectSend],
    ["direct-up", DirectUp],
    ["directbox-default", DirectboxDefault],
    ["directbox-notif", DirectboxNotif],
    ["directbox-receive", DirectboxReceive],
    ["directbox-send", DirectboxSend],
    ["discover", Discover],
    ["dislike", Dislike],
    ["document", Document],
    ["document-cloud", DocumentCloud],
    ["document-code", DocumentCode],
    ["document-code2", DocumentCode2],
    ["document-copy", DocumentCopy],
    ["document-download", DocumentDownload],
    ["document-favorite", DocumentFavorite],
    ["document-filter", DocumentFilter],
    ["document-forward", DocumentForward],
    ["document-like", DocumentLike],
    ["document-previous", DocumentPrevious],
    ["document-sketch", DocumentSketch],
    ["document-text", DocumentText],
    ["document-text1", DocumentText1],
    ["document-upload", DocumentUpload],
    ["drop", Drop],
    ["edit", Edit],
    ["edit-2", Edit2],
    ["electricity", Electricity],
    ["element", Element],
    ["element-2", Element2],
    ["element-3", Element3],
    ["element-4", Element4],
    ["element-equal", ElementEqual],
    ["element-plus", ElementPlus],
    ["emoji-happy", EmojiHappy],
    ["emoji-normal", EmojiNormal],
    ["emoji-sad", EmojiSad],
    ["empty-wallet", EmptyWallet],
    ["empty-wallet-add", EmptyWalletAdd],
    ["empty-wallet-change", EmptyWalletChange],
    ["empty-wallet-remove", EmptyWalletRemove],
    ["empty-wallet-tick", EmptyWalletTick],
    ["empty-wallet-time", EmptyWalletTime],
    ["eraser", Eraser],
    ["eraser-square", EraserSquare],
    ["export", Export],
    ["export-circle", ExportCircle],
    ["export-curve", ExportCurve],
    ["export-square", ExportSquare],
    ["external-drive", ExternalDrive],
    ["eye", Eye],
    ["eye-slash", EyeSlash],
    ["fatrows", Fatrows],
    ["favorite-chart", FavoriteChart],
    ["filter", Filter],
    ["filter-add", FilterAdd],
    ["filter-edit", FilterEdit],
    ["filter-remove", FilterRemove],
    ["filter-search", FilterSearch],
    ["filter-square", FilterSquare],
    ["filter-tick", FilterTick],
    ["finger-cricle", FingerCricle],
    ["finger-scan", FingerScan],
    ["firstline", Firstline],
    ["flag", Flag],
    ["flag-2", Flag2],
    ["flash", Flash],
    ["flash-circle", FlashCircle],
    ["flash-slash", FlashSlash],
    ["flashy", Flashy],
    ["folder", Folder],
    ["folder-2", Folder2],
    ["folder-add", FolderAdd],
    ["folder-cloud", FolderCloud],
    ["folder-connection", FolderConnection],
    ["folder-cross", FolderCross],
    ["folder-favorite", FolderFavorite],
    ["folder-minus", FolderMinus],
    ["folder-open", FolderOpen],
    ["forbidden", Forbidden],
    ["forbidden-2", Forbidden2],
    ["format-circle", FormatCircle],
    ["format-square", FormatSquare],
    ["forward", Forward],
    ["forward-5-seconds", Forward5Seconds],
    ["forward-10-seconds", Forward10Seconds],
    ["forward-15-seconds", Forward15Seconds],
    ["forward-item", ForwardItem],
    ["gallery", Gallery],
    ["gallery-add", GalleryAdd],
    ["gallery-edit", GalleryEdit],
    ["gallery-export", GalleryExport],
    ["gallery-favorite", GalleryFavorite],
    ["gallery-import", GalleryImport],
    ["gallery-remove", GalleryRemove],
    ["gallery-slash", GallerySlash],
    ["gallery-tick", GalleryTick],
    ["game", Game],
    ["gameboy", Gameboy],
    ["gas-station", GasStation],
    ["gemini", Gemini],
    ["gemini-2", Gemini2],
    ["ghost", Ghost],
    ["gift", Gift],
    ["glass", Glass],
    ["global", Global],
    ["global-edit", GlobalEdit],
    ["global-refresh", GlobalRefresh],
    ["global-search", GlobalSearch],
    ["google", Google],
    ["gps", Gps],
    ["gps-slash", GpsSlash],
    ["grammerly", Grammerly],
    ["graph", Graph],
    ["grid-1", Grid1],
    ["grid-2", Grid2],
    ["grid-3", Grid3],
    ["grid-4", Grid4],
    ["grid-5", Grid5],
    ["grid-6", Grid6],
    ["grid-7", Grid7],
    ["grid-8", Grid8],
    ["grid-9", Grid9],
    ["grid-edit", GridEdit],
    ["grid-eraser", GridEraser],
    ["grid-lock", GridLock],
    ["hamberger-menu", HambergerMenu],
    ["happyemoji", Happyemoji],
    ["hashtag", Hashtag],
    ["hashtag-down", HashtagDown],
    ["hashtag-up", HashtagUp],
    ["headphone", Headphone],
    ["headphones", Headphones],
    ["health", Health],
    ["heart", Heart],
    ["heart-add", HeartAdd],
    ["heart-circle", HeartCircle],
    ["heart-edit", HeartEdit],
    ["heart-remove", HeartRemove],
    ["heart-search", HeartSearch],
    ["heart-slash", HeartSlash],
    ["heart-tick", HeartTick],
    ["hierarchy", Hierarchy],
    ["hierarchy-2", Hierarchy2],
    ["hierarchy-3", Hierarchy3],
    ["hierarchy-square", HierarchySquare],
    ["hierarchy-square-2", HierarchySquare2],
    ["hierarchy-square-3", HierarchySquare3],
    ["home", Home],
    ["home-2", Home2],
    ["home-3", Home3],
    ["home-hashtag", HomeHashtag],
    ["home-trend-down", HomeTrendDown],
    ["home-trend-up", HomeTrendUp],
    ["home-wifi", HomeWifi],
    ["hospital", Hospital],
    ["house", House],
    ["house-2", House2],
    ["image", Image],
    ["import", Import],
    ["import-circle", ImportCircle],
    ["import-curve", ImportCurve],
    ["import-square", ImportSquare],
    ["info-circle", InfoCircle],
    ["information", Information],
    ["instagram", Instagram],
    ["judge", Judge],
    ["kanban", Kanban],
    ["key", Key],
    ["keyboard", Keyboard],
    ["keyboard-open", KeyboardOpen],
    ["key-square", KeySquare],
    ["lamp", Lamp],
    ["lamp-charge", LampCharge],
    ["lamp-on", LampOn],
    ["lamp-slash", LampSlash],
    ["language-circle", LanguageCircle],
    ["language-square", LanguageSquare],
    ["layer", Layer],
    ["level", Level],
    ["lifebuoy", Lifebuoy],
    ["like", Like],
    ["like-1", Like1],
    ["like-dislike", LikeDislike],
    ["like-shapes", LikeShapes],
    ["like-tag", LikeTag],
    ["link", Link],
    ["link-1", Link1],
    ["link-2", Link2],
    ["link-21", Link21],
    ["link-circle", LinkCircle],
    ["link-square", LinkSquare],
    ["location", Location],
    ["location-add", LocationAdd],
    ["location-cross", LocationCross],
    ["location-minus", LocationMinus],
    ["location-slash", LocationSlash],
    ["location-tick", LocationTick],
    ["lock", Lock],
    ["lock-1", Lock1],
    ["lock-circle", LockCircle],
    ["lock-slash", LockSlash],
    ["login", Login],
    ["login-curve", LoginCurve],
    ["logout", Logout],
    ["logout-curve", LogoutCurve],
    ["lovely", Lovely],
    ["magic-star", MagicStar],
    ["magicpen", Magicpen],
    ["main-component", MainComponent],
    ["man", Man],
    ["map", MapIcon],
    ["map-1", Map1],
    ["mask", Mask],
    ["mask-left", MaskLeft],
    ["mask-right", MaskRight],
    ["math", MathIcon],
    ["maximize", Maximize],
    ["maximize-1", Maximize1],
    ["maximize-2", Maximize2],
    ["maximize-3", Maximize3],
    ["maximize-4", Maximize4],
    ["maximize-circle", MaximizeCircle],
    ["medal", Medal],
    ["medal-star", MedalStar],
    ["menu", Menu],
    ["menu-board", MenuBoard],
    ["message", Message],
    ["message-2", Message2],
    ["message-add", MessageAdd],
    ["message-add-1", MessageAdd1],
    ["message-circle", MessageCircle],
    ["message-edit", MessageEdit],
    ["message-favorite", MessageFavorite],
    ["message-minus", MessageMinus],
    ["message-notif", MessageNotif],
    ["message-programming", MessageProgramming],
    ["message-question", MessageQuestion],
    ["message-remove", MessageRemove],
    ["message-search", MessageSearch],
    ["message-square", MessageSquare],
    ["message-text", MessageText],
    ["message-text-1", MessageText1],
    ["message-tick", MessageTick],
    ["message-time", MessageTime],
    ["messages", Messages],
    ["messages-1", Messages1],
    ["messages-2", Messages2],
    ["messages-3", Messages3],
    ["microphone", Microphone],
    ["microphone-2", Microphone2],
    ["microphone-slash", MicrophoneSlash],
    ["microphone-slash-1", MicrophoneSlash1],
    ["microscope", Microscope],
    ["milk", Milk],
    ["mini-music-sqaure", MiniMusicSqaure],
    ["minus", Minus],
    ["minus-cirlce", MinusCirlce],
    ["minus-square", MinusSquare],
    ["mirror", Mirror],
    ["mirroring-screen", MirroringScreen],
    ["mobile", Mobile],
    ["mobile-programming", MobileProgramming],
    ["money-recive", MoneyRecive],
    ["monitor", Monitor],
    ["monitor-mobbile", MonitorMobbile],
    ["monitor-recorder", MonitorRecorder],
    ["moon", Moon],
    ["more", More],
    ["more-2", More2],
    ["more-circle", MoreCircle],
    ["more-square", MoreSquare],
    ["mouse", Mouse],
    ["mouse-circle", MouseCircle],
    ["mouse-square", MouseSquare],
    ["music", Music],
    ["music-circle", MusicCircle],
    ["music-dashboard", MusicDashboard],
    ["music-filter", MusicFilter],
    ["music-library-2", MusicLibrary2],
    ["music-play", MusicPlay],
    ["music-playlist", MusicPlaylist],
    ["music-square", MusicSquare],
    ["music-square-add", MusicSquareAdd],
    ["music-square-remove", MusicSquareRemove],
    ["music-square-search", MusicSquareSearch],
    ["musicnote", Musicnote],
    ["next", Next],
    ["note", Note],
    ["note-1", Note1],
    ["note-add", NoteAdd],
    ["note-favorite", NoteFavorite],
    ["notepad", Notepad],
    ["notepad-2", Notepad2],
    ["note-remove", NoteRemove],
    ["note-square", NoteSquare],
    ["note-text", NoteText],
    ["notification", Notification],
    ["notification-1", Notification1],
    ["notification-bing", NotificationBing],
    ["notification-circle", NotificationCircle],
    ["notification-favorite", NotificationFavorite],
    ["notification-status", NotificationStatus],
    ["omega-circle", OmegaCircle],
    ["omega-square", OmegaSquare],
    ["paintbucket", Paintbucket],
    ["paperclip", Paperclip],
    ["paperclip-2", Paperclip2],
    ["password-check", PasswordCheck],
    ["path-tool", PathTool],
    ["path-tool-2", PathTool2],
    ["path-tool-square", PathToolSquare],
    ["pause", Pause],
    ["pause-circle", PauseCircle],
    ["pen-add", PenAdd],
    ["pen-close", PenClose],
    ["pen-remove", PenRemove],
    ["pen-tool", PenTool],
    ["pen-tool-2", PenTool2],
    ["people", People],
    ["percentage-circle", PercentageCircle],
    ["percentage-square", PercentageSquare],
    ["personalcard", Personalcard],
    ["pet", Pet],
    ["pharagraphspacing", Pharagraphspacing],
    ["picture-frame", PictureFrame],
    ["play", Play],
    ["play-add", PlayAdd],
    ["play-circle", PlayCircle],
    ["play-cricle", PlayCricle],
    ["play-remove", PlayRemove],
    ["pointer", Pointer],
    ["presention-chart", PresentionChart],
    ["previous", Previous],
    ["printer", Printer],
    ["printer-slash", PrinterSlash],
    ["profile", Profile],
    ["profile-2user", Profile2User],
    ["profile-add", ProfileAdd],
    ["profile-circle", ProfileCircle],
    ["profile-delete", ProfileDelete],
    ["profile-remove", ProfileRemove],
    ["profile-tick", ProfileTick],
    ["programming-arrow", ProgrammingArrow],
    ["programming-arrows", ProgrammingArrows],
    ["quote-down", QuoteDown],
    ["quote-down-circle", QuoteDownCircle],
    ["quote-down-square", QuoteDownSquare],
    ["quote-up", QuoteUp],
    ["quote-up-circle", QuoteUpCircle],
    ["quote-up-square", QuoteUpSquare],
    ["radar", Radar],
    ["radar-2", Radar2],
    ["radio", Radio],
    ["ram", Ram],
    ["ram-2", Ram2],
    ["rank", Rank],
    ["receive", Receive],
    ["receive-square", ReceiveSquare],
    ["receive-square-2", ReceiveSquare2],
    ["record", Record],
    ["record-circle", RecordCircle],
    ["recovery-convert", RecoveryConvert],
    ["refresh", Refresh],
    ["refresh-2", Refresh2],
    ["refresh-circle", RefreshCircle],
    ["refresh-left-square", RefreshLeftSquare],
    ["refresh-right-square", RefreshRightSquare],
    ["refresh-square", RefreshSquare],
    ["repeat", Repeat],
    ["repeat-circle", RepeatCircle],
    ["repeate-music", RepeateMusic],
    ["repeate-one", RepeateOne],
    ["reserve", Reserve],
    ["rotate-left", RotateLeft],
    ["rotate-right", RotateRight],
    ["route-square", RouteSquare],
    ["routing", Routing],
    ["routing-2", Routing2],
    ["row-horizontal", RowHorizontal],
    ["row-vertical", RowVertical],
    ["ruler", Ruler],
    ["ruler-pen", RulerPen],
    ["safe-home", SafeHome],
    ["sagittarius", Sagittarius],
    ["save-2", Save2],
    ["save-add", SaveAdd],
    ["save-minus", SaveMinus],
    ["save-remove", SaveRemove],
    ["scan", Scan],
    ["scan-barcode", ScanBarcode],
    ["scanner", Scanner],
    ["scanning", Scanning],
    ["scissor", Scissor],
    ["screenmirroring", Screenmirroring],
    ["scroll", Scroll],
    ["search-favorite", SearchFavorite],
    ["search-favorite-1", SearchFavorite1],
    ["search-normal", SearchNormal],
    ["search-normal-1", SearchNormal1],
    ["search-status", SearchStatus],
    ["search-status-1", SearchStatus1],
    ["search-zoom-in", SearchZoomIn],
    ["search-zoom-in-1", SearchZoomIn1],
    ["search-zoom-out", SearchZoomOut],
    ["search-zoom-out-1", SearchZoomOut1],
    ["security", Security],
    ["security-card", SecurityCard],
    ["security-safe", SecuritySafe],
    ["security-time", SecurityTime],
    ["security-user", SecurityUser],
    ["send", Send],
    ["send-2", Send2],
    ["setting", Setting],
    ["setting-2", Setting2],
    ["setting-3", Setting3],
    ["setting-4", Setting4],
    ["setting-5", Setting5],
    ["settings", Settings],
    ["shapes", Shapes],
    ["shapes-1", Shapes1],
    ["share", Share],
    ["shield", Shield],
    ["shield-cross", ShieldCross],
    ["shield-search", ShieldSearch],
    ["shield-security", ShieldSecurity],
    ["shield-slash", ShieldSlash],
    ["shield-tick", ShieldTick],
    ["ship", Ship],
    ["shop", Shop],
    ["shop-add", ShopAdd],
    ["shop-remove", ShopRemove],
    ["shopping-bag", ShoppingBag],
    ["shopping-cart", ShoppingCart],
    ["shuffle", Shuffle],
    ["sidebar-bottom", SidebarBottom],
    ["sidebar-left", SidebarLeft],
    ["sidebar-right", SidebarRight],
    ["sidebar-top", SidebarTop],
    ["signpost", Signpost],
    ["simcard", Simcard],
    ["simcard-1", Simcard1],
    ["simcard-2", Simcard2],
    ["size", Size],
    ["slash", Slash],
    ["slider", Slider],
    ["slider-horizontal", SliderHorizontal],
    ["slider-horizontal-1", SliderHorizontal1],
    ["slider-vertical", SliderVertical],
    ["slider-vertical-1", SliderVertical1],
    ["smallcaps", Smallcaps],
    ["smart-car", SmartCar],
    ["smart-home", SmartHome],
    ["smileys", Smileys],
    ["sms", Sms],
    ["sms-edit", SmsEdit],
    ["sms-notification", SmsNotification],
    ["sms-search", SmsSearch],
    ["sms-star", SmsStar],
    ["sms-tracking", SmsTracking],
    ["sort", Sort],
    ["sound", Sound],
    ["speaker", Speaker],
    ["speedometer", Speedometer],
    ["star", Star],
    ["star-1", Star1],
    ["star-slash", StarSlash],
    ["status", Status],
    ["status-up", StatusUp],
    ["sticker", Sticker],
    ["stickynote", Stickynote],
    ["stop", Stop],
    ["stop-circle", StopCircle],
    ["story", Story],
    ["strongbox", Strongbox],
    ["strongbox-2", Strongbox2],
    ["subtitle", Subtitle],
    ["sun", Sun],
    ["sun-1", Sun1],
    ["sun-fog", SunFog],
    ["table-document", TableDocument],
    ["table-lamp", TableLamp],
    ["tag", Tag],
    ["tag-2", Tag2],
    ["tag-cross", TagCross],
    ["tag-right", TagRight],
    ["tag-user", TagUser],
    ["task", Task],
    ["task-square", TaskSquare],
    ["teacher", Teacher],
    ["text", Text],
    ["text-block", TextBlock],
    ["text-bold", TextBold],
    ["text-italic", TextItalic],
    ["text-underline", TextUnderline],
    ["textalign-center", TextalignCenter],
    ["textalign-justifycenter", TextalignJustifycenter],
    ["textalign-justifyleft", TextalignJustifyleft],
    ["textalign-justifyright", TextalignJustifyright],
    ["textalign-left", TextalignLeft],
    ["textalign-right", TextalignRight],
    ["ticket", Ticket],
    ["ticket-2", Ticket2],
    ["ticket-discount", TicketDiscount],
    ["ticket-expired", TicketExpired],
    ["ticket-star", TicketStar],
    ["timer", Timer],
    ["timer-1", Timer1],
    ["timer-pause", TimerPause],
    ["timer-start", TimerStart],
    ["toggle-off", ToggleOff],
    ["toggle-off-circle", ToggleOffCircle],
    ["toggle-on", ToggleOn],
    ["toggle-on-circle", ToggleOnCircle],
    ["trade", Trade],
    ["translate", Translate],
    ["trash", Trash],
    ["tree", Tree],
    ["trend-down", TrendDown],
    ["trend-up", TrendUp],
    ["triangle", Triangle],
    ["trush-square", TrushSquare],
    ["truck", Truck],
    ["truck-fast", TruckFast],
    ["truck-remove", TruckRemove],
    ["truck-tick", TruckTick],
    ["truck-time", TruckTime],
    ["unlock", Unlock],
    ["unlimited", Unlimited],
    ["user", User],
    ["user-add", UserAdd],
    ["user-cirlce-add", UserCirlceAdd],
    ["user-edit", UserEdit],
    ["user-minus", UserMinus],
    ["user-octagon", UserOctagon],
    ["user-remove", UserRemove],
    ["user-search", UserSearch],
    ["user-square", UserSquare],
    ["user-tag", UserTag],
    ["user-tick", UserTick],
    ["verify", Verify],
    ["video", Video],
    ["video-add", VideoAdd],
    ["video-circle", VideoCircle],
    ["video-horizontal", VideoHorizontal],
    ["video-octagon", VideoOctagon],
    ["video-play", VideoPlay],
    ["video-remove", VideoRemove],
    ["video-slash", VideoSlash],
    ["video-square", VideoSquare],
    ["video-tick", VideoTick],
    ["video-time", VideoTime],
    ["video-vertical", VideoVertical],
    ["voice-cricle", VoiceCricle],
    ["voice-square", VoiceSquare],
    ["volume", Volume],
    ["volume-cross", VolumeCross],
    ["volume-high", VolumeHigh],
    ["volume-low", VolumeLow],
    ["volume-low-1", VolumeLow1],
    ["volume-mute", VolumeMute],
    ["volume-slash", VolumeSlash],
    ["volume-up", VolumeUp],
    ["wallet", Wallet],
    ["wallet-1", Wallet1],
    ["wallet-2", Wallet2],
    ["wallet-3", Wallet3],
    ["wallet-add", WalletAdd],
    ["wallet-add-1", WalletAdd1],
    ["wallet-check", WalletCheck],
    ["wallet-minus", WalletMinus],
    ["wallet-money", WalletMoney],
    ["wallet-remove", WalletRemove],
    ["wallet-search", WalletSearch],
    ["warning-2", Warning2],
    ["watch", Watch],
    ["watch-status", WatchStatus],
    ["weight", Weight],
    ["weight-meter", WeightMeter],
    ["wifi", Wifi],
    ["wifi-square", WifiSquare],
    ["wind", Wind],
    ["wind-2", Wind2],
    ["woman", Woman],
    ["wrist-clock", WristClock],
]);

export default saxIcons;
